import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Contact } from "@app/core/contact/domain/contact";

@Injectable({
  providedIn: "root",
})
export class SendMessageWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(message: Contact, token: string): Observable<void> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.HELP_MESSAGE_ENDPOINT())
      .setMethod(HttpMethod.post)
      .setBody(message)
      .setAuthorization(new TokenAuthorization(token))
      .build();

    return this.baseHandler.execute(parameters);
  }
}
